import { render, staticRenderFns } from "./AMFooter.vue?vue&type=template&id=fa8aa3e2&scoped=true"
import script from "./AMFooter.vue?vue&type=script&lang=js"
export * from "./AMFooter.vue?vue&type=script&lang=js"
import style0 from "./AMFooter.vue?vue&type=style&index=0&id=fa8aa3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8aa3e2",
  null
  
)

export default component.exports